import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
`;
